<div class="h-6 w-full">
  <div
    *ngIf="control.invalid && control.touched && errorMessage !== null"
    class="text-r600 pl-3 text-sm font-medium"
    >{{ errorMessage }}</div
  >
</div>
